import React from 'react';
import type { ResponsivePie as NivoResponsivePie } from '@nivo/pie';

const LazyResponsivePie = React.lazy(() =>
  import(/* webpackChunkName: "nivo-pie" */ '@nivo/pie').then((module) => ({
    default: module.ResponsivePie,
  }))
);

interface ResponsivePieProps
  extends React.ComponentProps<typeof NivoResponsivePie> {}

const ResponsivePie: React.FC<ResponsivePieProps> = (props) => (
  <LazyResponsivePie {...props} />
);

export default ResponsivePie;
